import Paper from '@mui/material/Paper';
import { appdata } from '../internalModules';
import { Button, Grid } from '@mui/material';
import React from 'react';
import {Scenario} from '../internalModules';
import UIScenarioCard from './UIScenarioCard';
import Plot from 'react-plotly.js';
import { Data } from 'plotly.js';
import {ScenarioRow} from '../internalModules';
import Graphics from '../Graphics';
import { TrackAnalyticsEvent } from '../analytics/analytics';
import { Create } from '@mui/icons-material';
import { CreateScenarioEvent } from '../analytics/events';


type Props = {
  updateApp: Function
}

export default function UIScenarioList({updateApp}: Props): JSX.Element {

  const handleAddScenario = () => {
    const scenarios = appdata.getScenarioArray()
    let lastScenario = scenarios[scenarios.length - 1]
    const newScenario = new Scenario()
    newScenario.setCalcMethod(lastScenario.calcMethod)
    newScenario.setTotalArea(lastScenario.totalArea)
    newScenario.rows = []
    for (const row of lastScenario.rows) {
      const newRow = new ScenarioRow(newScenario)
      newRow.wTypeId = row.wTypeId
      newRow.amount = row.amount
      newScenario.rows.push(newRow)
    }
    appdata.createScenario(newScenario);
    TrackAnalyticsEvent(CreateScenarioEvent)
    forceUpdate();
  }

  const updateScenarios = () => {
    updateApp();
  }

  const getPlotDataBar = () => {
    //generate data object for plot
    let data = [] as Data[]
    for (const wtype of appdata.getWallTypeArray()) {
      let wtData = {
        x: [] as string[],
        y: [] as number[],
        text: [] as string[],
        name: wtype.name,
        type: 'bar',
      }
      for (const scenario of appdata.getScenarioArray()) {
        for (const row of scenario.rows) {
          if (row.wTypeId === wtype.guid) {
            wtData.x.push(scenario.name)
            wtData.y.push(row.gwp / 1000)
            wtData.text.push(wtype.name)
          }
        }
      }
      data.push(wtData as Data)
      
    }
    return data
  }

  const getPlotDataDeltas = () => {
    //generate data object for baseline delta plot
    let baselineScenario = appdata.getScenarioBaseline()
    let otherScenarios: Scenario[] = []
    for (const s of appdata.scenarios.values()) {
      if (!s.isBaseline) {
        otherScenarios.push(s)
      }
    }

    let data = [] as Data[]
    let scenarioData = {
      x: [] as string[],
      y: [] as number[],
      text: [] as string[],
      marker: { color: [] as string[]},
      type: 'bar'
    }
    if (otherScenarios.length > 0) {
      for (const scenario of otherScenarios) {
        const basegwp = baselineScenario.gwp
        const gwp = scenario.gwp
        scenarioData.x.push( scenario.name )
        scenarioData.y.push( Number.parseFloat(((gwp - basegwp) / basegwp * 100).toFixed(1)) )
        const prefix = gwp-basegwp > 0? '+' : ''
        scenarioData.text.push( prefix + ((gwp - basegwp) / basegwp * 100).toFixed(1) + '%' )
        if ( gwp-basegwp > 0 ) {
          scenarioData.marker.color.push('#005073')
        }
        else {
          scenarioData.marker.color.push('#71c7ec')
        }
      }
    }
    
    data.push(scenarioData as Data)
    return data
  }

  const deleteScenario = (guid: string) => {
    appdata.deleteScenario(guid);
    forceUpdate();
  }

  const forceUpdate: () => void = React.useState({})[1].bind(null, {});
  
  const colorway: string[] = Graphics.getAssemblyColors()
  
  return (
    <Grid container p={3} sx={{backgroundColor: '#f4f4f4'}}>
      <Grid item sm={4} p={1} >
        <Plot
          className='plot'
          data={getPlotDataBar()}
          layout={{
            barmode: 'stack',
            bargap: 0.05,
            autosize: true,
            title: 'MTCO2e by Scenario',
            paper_bgcolor: 'rgb(244, 244, 244)',
            plot_bgcolor: 'rgb(244, 244, 244)',
            //colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
            //colorway: ['#636EFA', '#EF553B', '#00CC96', '#AB63FA', '#FFA15A', '#19D3F3', '#FF6692', '#B6E880', '#FF97FF', '#FECB52']
            //colorway: ['#005073', '#107dac', '#189ad3', '#1ebbd7', '#71c7ec']
            colorway: colorway
            
          }}
          config={{responsive: true}}
          style={{width: "100%", height: 500}}
          useResizeHandler={true}
        />
        <Plot
          className='plot'
          data={getPlotDataDeltas()}
          layout={{
            bargap: 0.05,
            autosize: true,
            title: 'MTCO2e Delta from Baseline',
            paper_bgcolor: 'rgb(244, 244, 244)',
            plot_bgcolor: 'rgb(244, 244, 244)',
            //colorway: ['#005073'],
            yaxis: {
              title: `% CO2e of Baseline: ${appdata.getScenarioBaseline().name}`,
              ticksuffix: '%'
            },
            margin: { r: 140}
          }}
          config={{responsive: true}}
          style={{width: "100%", height: 500}}
          useResizeHandler={true}
        />
        
      </Grid>
      <Grid item sm={7.75} xl={7}>
        {Array.from(appdata.scenarios.values()).map( (item, index) => (
          <UIScenarioCard
            index={index}
            key={item.guid}
            scenarioId={item.guid}
            deleteScenario={deleteScenario}
            updateScenarios={updateScenarios}
          />
        ))}
        <Paper sx={{p: 2, m:1}}>
          <Button
            variant='outlined'
            size="small"
            sx={{minHeight: 40}}
            fullWidth
            onClick={handleAddScenario}
          >
            Add Scenario
          </Button>
        </Paper>
      </Grid>

    </Grid>
    
  );
}
